export function dateFormat(date, separator = ' ') {
  const d = new Date(date);
  const month = d.toLocaleString('default', { month: 'short' });
  const year = d.getFullYear();
  const day = d.toLocaleString('default', { day: '2-digit' });

  return [day, month, year].join(separator);
}

export function dateFormatNumeric(date, separator = ' ') {
  const d = new Date(date);
  const month = d.toLocaleString('default', { month: '2-digit' });
  const year = d.getFullYear();
  const day = d.toLocaleString('default', { day: '2-digit' });

  return [day, month, year].join(separator);
}

export function dateFormatMonthYear(date, separator = ' ') {
  const d = new Date(date);
  const month = d.toLocaleString('default', { month: 'short' });
  const year = d.getFullYear();

  return [month, year].join(separator);
}
